module.exports = __webpack_public_path__ + "static/media/ExpandMore.488fb9cb.svg";